import { useCallback } from 'react';
import Constants from '../Constants';
import { useAuth } from '../AuthContext';

const BackendUrl = Constants.SERVER_URL;

function useSocket(on_transcription, on_error) {
	const { token } = useAuth();

	const send_audio_chunk = useCallback(async (buffer) => {
		try {
			const headers = { 'Content-Type': 'audio/webm' };
			if(token) { headers['Authorization'] = 'Bearer ' + token; }
			const response = await fetch(BackendUrl + '/api/transcribe', {
				method: 'POST',
				headers,
				body: buffer
			});
			if(!response.ok) {
				throw new Error('Server error: ' + response.status);
			}
			const data = await response.json();
			if(data.text && data.text.trim()) {
				on_transcription(data.text);
			}
		} catch (error) {
			on_error(error.message);
		}
	}, [on_transcription, on_error, token]);

	return { connected: true, send_audio_chunk };
}

export default useSocket;
